import { CAMPAIGNS, STATS } from "../configs/routes.js";
import api from "./api.js";

export const createCampaign = (payload) =>
    new Promise((resolve, reject) => {
        api
            .post(CAMPAIGNS, payload, { timeout: 60000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

export const getCampaigns = (params = {}) =>
    new Promise((resolve, reject) => {
        api
            .get(CAMPAIGNS, { params, timeout: 60000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

export const getCampaign = (id) =>
    new Promise((resolve, reject) => {
        api
            .get(`${CAMPAIGNS}/${id}`, {
                timeout: 60000,
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

export const publishCampaign = (id, payload) =>
    new Promise((resolve, reject) => {
        api
            .post(`${CAMPAIGNS}/${id}/publish`, payload, { timeout: 60000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

export const getStats = () =>
    new Promise((resolve, reject) => {
        api
            .get(STATS, { timeout: 60000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

